var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptimism(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4594_7863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.434 107.771C53.6721 107.771 48.9543 106.405 45.2806 103.674C41.6456 100.904 39.8281 96.9237 39.8281 91.8123C39.8281 90.7197 39.9441 89.4321 40.1762 87.8714C40.7949 84.3597 41.6843 80.1457 42.8444 75.1903C46.1314 61.7679 54.6389 55.0566 68.3282 55.0566C72.0405 55.0566 75.4048 55.6809 78.3438 56.9686C81.2827 58.1781 83.603 60.051 85.3044 62.5482C87.0059 65.0064 87.8567 67.9328 87.8567 71.3274C87.8567 72.3419 87.7407 73.6295 87.5087 75.1903C86.7739 79.5214 85.9232 83.7744 84.8791 87.8714C83.1776 94.5436 80.2773 99.577 76.1009 102.894C71.9632 106.171 66.3947 107.771 59.434 107.771ZM60.4781 97.2359C63.185 97.2359 65.4666 96.4165 67.3614 94.8167C69.2949 93.217 70.6871 90.7588 71.4991 87.4032C72.6206 82.799 73.4713 78.819 74.0514 75.3854C74.2447 74.3709 74.3607 73.3174 74.3607 72.2249C74.3607 67.7767 72.0792 65.5527 67.4774 65.5527C64.7705 65.5527 62.4503 66.3721 60.5168 67.9718C58.6219 69.5716 57.2684 72.0298 56.4564 75.3854C55.567 78.663 54.7162 82.6429 53.8268 87.4032C53.6334 88.3786 53.5174 89.3931 53.5174 90.4856C53.4788 95.0118 55.8376 97.2359 60.4781 97.2359Z",
    fill: "url(#paint0_linear_4594_7863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5912 106.599C90.0265 106.599 89.6231 106.446 89.3004 106.101C89.0584 105.718 88.9777 105.296 89.0584 104.798L99.5061 58.0298C99.5868 57.4931 99.8692 57.0714 100.353 56.7264C100.797 56.3814 101.281 56.2281 101.805 56.2281H121.934C127.542 56.2281 132.019 57.3398 135.408 59.5248C138.836 61.7482 140.571 64.93 140.571 69.1084C140.571 70.2968 140.41 71.5618 140.127 72.8652C138.877 78.3854 136.335 82.4488 132.463 85.0939C128.671 87.739 123.467 89.0423 116.852 89.0423H106.646L103.177 104.798C103.056 105.334 102.814 105.756 102.33 106.101C101.886 106.446 101.402 106.599 100.878 106.599H90.5912ZM117.376 79.1137C119.514 79.1137 121.329 78.577 122.903 77.4653C124.516 76.3536 125.565 74.7819 126.089 72.7119C126.251 71.9068 126.331 71.1785 126.331 70.5651C126.331 69.1851 125.888 68.1117 125.041 67.3834C124.193 66.6167 122.701 66.2334 120.644 66.2334H111.567L108.703 79.1137H117.376Z",
    fill: "url(#paint1_linear_4594_7863)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4594_7863",
    x: 31.8281,
    y: 51.0566,
    width: 116.742,
    height: 68.7144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.0117647 0 0 0 0 0.670588 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4594_7863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4594_7863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4594_7863",
    x1: 90.1996,
    y1: 55.0566,
    x2: 90.1996,
    y2: 107.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF03B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4594_7863",
    x1: 90.1996,
    y1: 55.0566,
    x2: 90.1996,
    y2: 107.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF03B4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimism);
export default __webpack_public_path__ + "static/media/optimism.67207c93775bdfa5bed438d0a1927ebf.svg";
export { ForwardRef as ReactComponent };